module.exports = __webpack_public_path__ + "assets/img/White.b312998a.svg";